import { useQuery } from '@tanstack/react-query';
import { usersApi } from '@/services/api';

export function useAuth() {
  const { data: user, isLoading, error } = useQuery({
    queryKey: ['auth', 'user'],
    queryFn: () => usersApi.me(),
    staleTime: 10 * 60 * 1000,
    retry: false,
  });

  return { user, isLoading, error, isAuthenticated: !!user };
}
